/**
 * Supplier Default Fee API
 * 협력사 기본 수수료 관리 API (신규 라이더 자동 적용용)
 */
import { apiClient } from "@/shared/api/client";

const BASE_PATH = "/api/v1/supplier-default-fees";

/** 협력사 기본 수수료 정보 DTO */
export interface DefaultFeeDto {
  feeCode: string;
  feeName: string;
  feeType: string; // 'S': 협력사 수수료
  calcType: string; // '1': 정액, '2': 정률
  feeAmt: number | null;
  feeRate: number | null;
  settlementPeriod: string; // 'DAILY', 'WEEKLY'
  startDay: string;
  endDay: string;
  useYn: string;
}

/** 협력사 기본 수수료 저장 요청 DTO */
export interface SaveDefaultFeeRequest {
  suppId: string;
  feeCode: string;
  feeName: string;
  calcType: string; // '1': 정액, '2': 정률
  feeAmt: number | null;
  feeRate: number | null;
  settlementPeriod: string;
  startDay?: string; // 선택사항 - 백엔드에서 수요일 기반으로 자동 계산
  endDay?: string; // 선택사항 - 기본값 9999-12-31
  userId: string;
}

/** 협력사 기본 수수료 저장 응답 DTO */
export interface SaveDefaultFeeResponse {
  suppId: string;
  applyStartDate: string; // yyyy-MM-dd 형식
  isImmediateApply: boolean; // 수요일에 설정한 경우 true
}

/**
 * Supplier Default Fee API 서비스
 */
export const supplierDefaultFeeApi = {
  /**
   * 협력사 기본 수수료 목록 조회
   * GET /api/v1/supplier-default-fees?suppId={suppId}
   */
  getDefaultFees: async (suppId: string): Promise<DefaultFeeDto[]> => {
    const response = await apiClient.get<DefaultFeeDto[]>(BASE_PATH, {
      params: { suppId },
    });
    return response.data;
  },

  /**
   * 협력사 기본 수수료 저장
   * POST /api/v1/supplier-default-fees
   */
  saveDefaultFee: async (request: SaveDefaultFeeRequest): Promise<SaveDefaultFeeResponse> => {
    const response = await apiClient.post<SaveDefaultFeeResponse>(BASE_PATH, request);
    return response.data;
  },

  /**
   * 협력사 기본 수수료 삭제
   * DELETE /api/v1/supplier-default-fees?suppId={suppId}&feeCode={feeCode}
   */
  deleteDefaultFee: async (suppId: string, feeCode: string): Promise<void> => {
    await apiClient.delete<void>(BASE_PATH, {
      params: { suppId, feeCode },
    });
  },
};
